/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { fetchData, toasterrormsg } from '../../../reusable'
import { Tr } from '../../../_metronic/i18n/Tr';

interface AddHotelHeaderProps {
  hotelId: string; // Assuming hotelId is of type string, adjust as needed
}
const AddHotelHeader: React.FC<AddHotelHeaderProps> = ({ hotelId }) => {
  const t = Tr()
  const location = useLocation();
  const editHotelId = (location.state as any)?.hotelId || '';

  const [hotelDetails, setHotelDetails] = useState([]);
  // hotel Details api call
  const hotelDetailsApiCall = async () => {
    if (hotelId != "") {

      var param: any = {
        hotelId: hotelId,
      }
    } else if (editHotelId != "") {
      var param: any = {
        hotelId: editHotelId,
      }
    }
    var response: any = await fetchData("public/hotelDetailsV2", param)

    if (response.status == "200") {
      setHotelDetails(response.data);
    }
    else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {

    if (editHotelId != "") {
      hotelDetailsApiCall()
    }

  }, [])

  const tabRefs = useRef([]) as any;
  const indexTab = sessionStorage.getItem('indexTab') || 0;

  useEffect(() => {
    const scrollToTab = () => {
      // Check if the tabRefs array is populated and if the indexTab element exists
      if (tabRefs.current.length > 0 && tabRefs.current[indexTab]) {
        // Delay scrollIntoView to ensure all rendering is complete
        setTimeout(() => {
          tabRefs?.current[indexTab]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',  // Scroll vertically to nearest edge
            inline: 'center'   // Scroll horizontally to center
          });
        }, 700);
      }
    };
    scrollToTab();
    // Add event listener for window load event to handle case of page refresh
    window.addEventListener('load', scrollToTab);
    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('load', scrollToTab);
    };
  }, [location, indexTab]);
  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body'>
          <div className='d-flex overflow-auto'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder my-2 flex-nowrap'>
              <li className='nav-item'>
                {
                  hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['basicInfo'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['basicInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhotelbasicinfo/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['basicInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addhotelbasicinfo/'
                      state={{ hotelId: editHotelId }}
                      ref={el => (tabRefs.current[0] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '0')}
                    >
                      {t('Basic Info')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['basicInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhotelbasicinfo/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['basicInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[0] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '0')}
                    >
                      {t('Basic Info')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['location'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['location'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhotellocation/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['location'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addhotellocation/'
                      state={{ hotelId: editHotelId }}
                      ref={el => (tabRefs.current[1] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '1')}
                    >
                      {t('Location')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['location'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhotellocation/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['location'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[1] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '1')}
                    >
                      {t('Location')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['propertyDetail'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['propertyDetail'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhoteldetails/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['propertyDetail'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addhoteldetails/'
                      state={{ hotelId: editHotelId }}
                      ref={el => (tabRefs.current[2] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '2')}
                    >
                      {t('Property Details')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['propertyDetail'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhoteldetails/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['propertyDetail'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[2] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '2')}
                    >
                      {t('Property Details')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['policies'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['policies'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhotelpolicies/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['policies'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addhotelpolicies/'
                      state={{ hotelId: editHotelId }}
                      ref={el => (tabRefs.current[3] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '3')}
                    >
                      {t('Policies')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['policies'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhotelpolicies/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['policies'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[3] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '3')}
                    >
                      {t('Policies')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['roomAndSpace'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['roomAndSpace'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewrooms/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['roomAndSpace'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../viewrooms/'
                      state={{ hotelId: editHotelId }}
                      ref={el => (tabRefs.current[4] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '4')}
                    >
                      {t('Room & Spaces')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['roomAndSpace'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewrooms/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['roomAndSpace'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[4] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '4')}
                    >
                      {t('Room & Spaces')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['photos'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['photos'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhotelphotos/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['photos'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addhotelphotos/'
                      state={{ hotelId: editHotelId }}
                      ref={el => (tabRefs.current[5] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '5')}
                    >
                      {t('Photos')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['photos'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhotelphotos/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['photos'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[5] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '5')}
                    >
                      {t('Photos')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['facilitiesAndServices'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['facilitiesAndServices'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhotelfacilities/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['facilitiesAndServices'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addhotelfacilities/'
                      state={{ hotelId: editHotelId }}
                      ref={el => (tabRefs.current[6] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '6')}
                    >
                      {t('Facilities & Services')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['facilitiesAndServices'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhotelfacilities/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['facilitiesAndServices'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[6] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '6')}
                    >
                      {t('Facilities & Services')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['financeAndLegal'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['financeAndLegal'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhotelfinance/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['financeAndLegal'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addhotelfinance/'
                      state={{ hotelId: editHotelId }}
                      ref={el => (tabRefs.current[7] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '7')}
                    >
                      {t('Finance & Legal')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['financeAndLegal'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addhotelfinance/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['financeAndLegal'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[7] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '7')}
                    >
                      {t('Finance & Legal')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['contract'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['contract'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewhotelcontract/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['contract'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../viewhotelcontract/'
                      state={{ hotelId: editHotelId }}
                      ref={el => (tabRefs.current[8] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '8')}
                    >
                      {t('Contract Agreement')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['contract'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewhotelcontract/' ? `${hotelDetails && hotelDetails.length > 0 && hotelDetails[0]['completedSteps'] && hotelDetails[0]['completedSteps']['contract'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[8] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '8')}
                    >
                      {t('Contract Agreement')}
                    </button>
                  )
                }
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export { AddHotelHeader }
